module.exports = __webpack_public_path__ + "img/nodata.82c8710b.gif";